import React from 'react';
import { motion } from 'framer-motion';
export function FloatingCTA() {
  return <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden p-3 bg-[#0A0A0A]/95 backdrop-blur-sm border-t border-zinc-800" data-id="element-22">
      <motion.button whileTap={{
      scale: 0.97
    }} onClick={() => {
      const el = document.getElementById('pricing');
      if (el) el.scrollIntoView({
        behavior: 'smooth'
      });
    }} className="w-full bg-brand hover:bg-brand-dark text-[#0A0A0A] font-display font-bold text-lg py-4 px-6 rounded uppercase tracking-wider transition-colors shadow-[0_0_24px_rgba(212,160,23,0.25)]" data-id="element-23">
        Descargar "protocolo-hora extra"
      </motion.button>
    </div>;
}